import { Button } from 'components/Button/Button';
import { Modal } from 'components/Modal/Modal';
import { Portal } from 'components/Portal/Portal';
import { useTranslation } from 'react-i18next';

type RemoveConfirmModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    isChild: boolean;
};

export const RemoveConfirmModal: React.FC<RemoveConfirmModalProps> = ({ isOpen, onClose, onConfirm, isChild }) => {
    const { t } = useTranslation('member', { keyPrefix: 'removeModal' });
    return (
        <Portal>
            <Modal isOpen={isOpen} onClose={onClose} maxWidth={512}>
                <div className="flex flex-col gap-4">
                    <div className="text-xl font-semibold text-zinc-700 mb-2">
                        {isChild ? t('childTitle') : t('petTitle')}
                    </div>
                    <div className="flex justify-end gap-2">
                        <Button variant="outline" onClick={onClose}>
                            {t('cancelButton')}
                        </Button>
                        <Button onClick={onConfirm}>{t('confirmButton')}</Button>
                    </div>
                </div>
            </Modal>
        </Portal>
    );
};
